/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from 'react';

import {useScroll} from "../../../Hooks/ScrollHooks";

export const StreamBankScrollListenerEnhance = ((ComposedComponent) => function StreamBankScrollListenerEnhance(props) {
    const {scroll, scrollDirection} = useScroll();

    return <ComposedComponent
        {...props}
        ScrollHandler={{
            Scroll: scroll,
            ScrollDirection: scrollDirection,
        }}
    />;
});

